(function (module) {
    'use strict';

    function AdminAddAccountCtrl(Account, $state) {
        this.$onInit = () => {
            this.account = {
                type: 'free',
                trialPeriod: 30,
                beta: false,
                customApps: false,
                codePinPairing: false,
                enabled: true,
                accountVerified: true,
                subscriptions: 10,
            };
        };
        this.checkType = () => {
            if (this.account.type === 'paid') {
                this.account.startDate = new Date();
            }
            if (this.account.type === 'free') {
                this.account.startDate = null;
            }
        };

        this.save = () => {
            this.apiError = {};
            Account
                .createAccountWithPrimaryUser({ account: this.account, user: this.user })
                .$promise
                .then((response) => {
                    $state.go('root.admin.accounts.view', { accountId: response.account.id });

                })
                .catch((error) => {
                    if (error.status === 422) {
                        this.apiError.message = 'Email already exists';
                    }

                });
        };
    }

    module
        .component('adminAddAccountComponent', {
            templateUrl: '/js/admin/accounts/add-account/add-account.html',
            controller: AdminAddAccountCtrl
        })
        .config(($stateProvider) => {
            $stateProvider
                .state('root.admin.accounts.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'ADMIN_ACCOUNTS_ADD.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<admin-add-account-component/>'
                        }
                    }
                });

        });

})(angular.module('rocket.components'));
